import { render, staticRenderFns } from "./ProxyCard.vue?vue&type=template&id=75a62db7"
import script from "./ProxyCard.vue?vue&type=script&lang=js"
export * from "./ProxyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports